import Tooltip from './Tooltip'
import TooltipWithEllipsis from './TooltipWithEllipsis'

export default Tooltip

export { TooltipWithEllipsis }
